/* eslint-disable @typescript-eslint/no-explicit-any */
import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { GetTaskListingType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getTaskListing = (payload: GetTaskListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}getTaskListing`, payload);
      dispatch({
        type: action_types.GET_TASKS_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_TASKS_LISTING,
        data: { loading: false, payload: [], count: 0 },
      });
    }
  };
};

export const removeTaskListData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_TASKS_LISTING,
      data: { payload: [], loading: true },
    });
  };
};

export const getTaskDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getTaskDetails/${id}`);
      dispatch({
        type: action_types.GET_TASKS_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_TASKS_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removeTaskDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_TASKS_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};

export const getTaskFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getTaskFormData/${id}`);
      dispatch({
        type: action_types.TASK_FORM_DATA,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.TASK_FORM_DATA,
        data: { loading: false, payload: {} },
      });
    }
  };
};

export const getWorkOrdersListing = (payload: any) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getWorkOrderListing`,
        payload
      );
      dispatch({
        type: action_types.GET_WORK_ORDERS_LISTING,
        data: { payload: data.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_WORK_ORDERS_LISTING,
        data: { loading: false, payload: [], count: 0 },
      });
    }
  };
};

export const removeWorkOrdersListData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_WORK_ORDERS_LISTING,
      data: { payload: [], loading: true },
    });
  };
};

export const getWorkOrderDetails = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getWorkOrderDetails/${id}`);
      dispatch({
        type: action_types.GET_WORK_ORDERS_DETAIL,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_WORK_ORDERS_DETAIL,
        data: { loading: false },
      });
    }
  };
};

export const removeWorkOrderDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_WORK_ORDERS_DETAIL,
      data: { payload: {}, loading: true },
    });
  };
};
